import { TextField } from '@mui/material';
/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';

const StyledInput = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#F5F7FA',
    height: '40px',
    '& input': {
      padding: '8px 14px',
      fontSize: '14px'
    },
    '& fieldset': {
      borderColor: '#E5E7EB'
    },
    '&:hover fieldset': {
      borderColor: '#D1D5DB'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#D1D5DB'
    }
  },
  '& .MuiInputLabel-root': {
    fontSize: '14px',
    transform: 'translate(14px, 12px) scale(1)',
    '&.MuiInputLabel-shrink': {
      transform: 'translate(14px, -9px) scale(0.75)'
    }
  }
});

export default StyledInput;
